export enum GlobalVpaSubStatus {
  WaitingForAgent,
  WaitingForVendor,
  Appraisal,
  Draft
}
